import { apiGet } from './client';
import type { FeeType, FundFeeLogCheckResponse } from '../types/FundFeeLog';

// GET /api/fund-fee-log/check?fundId=&feeType=trustee|management — checked
// by the fund-form save flow whenever trusteeFeePercent/managementFeePercent
// changed from the loaded value, BEFORE the save request goes out.
export function checkFundFeeLog(
  fundId: number,
  feeType: FeeType,
): Promise<FundFeeLogCheckResponse> {
  const qs = new URLSearchParams({ fundId: String(fundId), feeType });
  return apiGet<FundFeeLogCheckResponse>(`/api/fund-fee-log/check?${qs.toString()}`);
}
